import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { useRecordContext } from "react-admin";
import { DormitoryAccommodationPaymentStatuses } from "utils/constants";
import RecordPaymentDialog from "./RecordPaymentDialog";
import RefundDialog from "./RefundDialog";

const AccommodationPaymentActions = () => {
  const record = useRecordContext();
  const isPaid = record?.status === DormitoryAccommodationPaymentStatuses.Paid;
  const canRefund = isPaid && !record?.refundMarkedAt;
  // Mirrors the backend guard in RecordAccommodationPaymentAdminHandler: an available, unpaid bill
  // with no debt, no earlier manual record and nothing flagged for review.
  const canRecord =
    record?.status === DormitoryAccommodationPaymentStatuses.Pending &&
    record?.isAvailable &&
    !record?.requiresReview &&
    !record?.debtId &&
    !record?.manualPaymentReference;

  if (!canRefund && !canRecord) {
    return null;
  }

  return (
    <SecuredComponent permission={permissions.canManageDormitoryPayments}>
      {canRecord && <RecordPaymentDialog />}
      {canRefund && <RefundDialog />}
    </SecuredComponent>
  );
};

export default AccommodationPaymentActions;
